module.exports = __webpack_public_path__ + "media/bell_prepared.9efcc2e3.mp4";